import { useCallback } from 'react';

import {
  markNotificationsAsDismissed,
  markNotificationsAsRead,
} from 'modules/main/store/ducks/userNotifications';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { getMappedNotificationIds } from 'utils/userNotifications';

import { BaseNotification } from './BaseNotification';

type Props = {
  notification: MappedNotification;
  dismisseable: boolean;
  onClick?: () => void;
};

export function UserNotification({
  notification,
  dismisseable,
  onClick,
}: Props) {
  const dispatch = useMainDispatch();

  const handleClick = useCallback(() => {
    dispatch(markNotificationsAsRead(getMappedNotificationIds(notification)));
    onClick?.();
  }, [dispatch, notification, onClick]);

  const handleDismiss = useCallback(
    () =>
      dispatch(
        markNotificationsAsDismissed(getMappedNotificationIds(notification)),
      ),
    [dispatch, notification],
  );

  return (
    <BaseNotification
      notification={notification}
      onClick={handleClick}
      onDismiss={dismisseable ? handleDismiss : undefined}
      qaId="notification"
    />
  );
}
